<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <el-tabs @tab-click="handleClick" v-model="orderStatus">
        <el-tab-pane label="全部">
          <afterItems orderStatus="0" v-if="orderStatus == '0'" />
        </el-tab-pane>
        <el-tab-pane label="待處理">
          <afterItems orderStatus="1" v-if="orderStatus === '1'" />
        </el-tab-pane>
        <el-tab-pane label="處理中">
          <afterItems orderStatus="2" v-if="orderStatus === '2'" />
        </el-tab-pane>
        <el-tab-pane label="已完成">
          <afterItems orderStatus="3" v-if="orderStatus === '3'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import afterItems from "./afterItems.vue";
export default {
  data() {
    return {
      navBlock: "訂單",
      navtitle: "售后訂單",
      orderStatus: "1"
    };
  },
  created() {},

  destroyed() {},
  methods: {
    handleClick(tab, events) {
        this.orderStatus = tab.paneName;
    }
  },
  components: {
    NavBar,
    afterItems
  }
};
</script>

<style lang="less" scoped>
@import "./el_tabs.less";
.content {
  .paddingContent {
    width: 100%;
    overflow: auto;
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/allOrder/afterSalesList.vue